/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationReference } from './HomeHealthCertificationReference';
import {
    HomeHealthCertificationReferenceFromJSON,
    HomeHealthCertificationReferenceFromJSONTyped,
    HomeHealthCertificationReferenceToJSON,
    HomeHealthCertificationReferenceToJSONTyped,
} from './HomeHealthCertificationReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationF2fAttestation
 */
export interface HomeHealthCertificationF2fAttestation {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationF2fAttestation
     */
    status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReference>}
     * @memberof HomeHealthCertificationF2fAttestation
     */
    ref: Array<HomeHealthCertificationReference>;
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertificationF2fAttestation
     */
    encounter_date: string;
}



/**
 * Check if a given object implements the HomeHealthCertificationF2fAttestation interface.
 */
export function instanceOfHomeHealthCertificationF2fAttestation(value: object): value is HomeHealthCertificationF2fAttestation {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ref' in value) || value['ref'] === undefined) return false;
    if (!('encounter_date' in value) || value['encounter_date'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationF2fAttestationFromJSON(json: any): HomeHealthCertificationF2fAttestation {
    return HomeHealthCertificationF2fAttestationFromJSONTyped(json, false);
}

export function HomeHealthCertificationF2fAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationF2fAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'status': HomeHealthCertificationStatusFromJSON(json['status']),
        'ref': ((json['ref'] as Array<any>).map(HomeHealthCertificationReferenceFromJSON)),
        'encounter_date': json['encounter_date'],
    };
}

export function HomeHealthCertificationF2fAttestationToJSON(json: any): HomeHealthCertificationF2fAttestation {
    return HomeHealthCertificationF2fAttestationToJSONTyped(json, false);
}

export function HomeHealthCertificationF2fAttestationToJSONTyped(value?: HomeHealthCertificationF2fAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': HomeHealthCertificationStatusToJSON(value['status']),
        'ref': ((value['ref'] as Array<any>).map(HomeHealthCertificationReferenceToJSON)),
        'encounter_date': value['encounter_date'],
    };
}

